module.exports = __webpack_public_path__ + "static/media/gryphonhouse-adjusted-logo-gold.96edd3ad.svg";